import { IonButton, IonText } from '@ionic/react';
import React, { Fragment, useContext, useState } from 'react';
import { Redirect } from 'react-router';
import { CONVERSATION_STATUS, EXCEPTIONS } from '../../constants';
import {
  ConversationContext,
  PaymentContext,
  TranslationContext,
} from '../../contexts';
import { Conversation } from '../../models';
import { conversationResource } from '../../resource';

interface Props {
  className?: string;
  shortCode?: string;
  showAvailability?: boolean;
  text?: string;
}

export const StartChatWithCharacterButton = ({
  text,
  className,
  showAvailability,
  shortCode,
}: Props) => {
  const { translate } = useContext(TranslationContext);
  const { setDisplayPaymentPopup } = useContext(PaymentContext);
  const { readOnly } = useContext(ConversationContext);
  const [redirectTo, setRedirectTo] = useState<{
    pathname: string;
    state: any;
  } | null>(null);

  const startConversation = async (e: any) => {
    e.stopPropagation();

    let conversation;

    try {
      conversation = await conversationResource.findByCharacter(shortCode);

      if (conversation) {
        if (!conversation.affordable) {
          throw new Error(EXCEPTIONS.NO_ENOUGH_CREDIT);
        }
      }
    } catch (error: unknown) {
      const err = error as Error;
      if (err.message.endsWith(EXCEPTIONS.NO_ENOUGH_CREDIT)) {
        if (!readOnly) {
          setDisplayPaymentPopup(true);
        }
      }
      if (err.message.endsWith(EXCEPTIONS.EXPERT_NOT_AVAILABLE)) {
        // TODO Add error message alert("Not available");
        window.location.replace('/character/{$shortCode}');
      }
    }

    if (conversation) {
      setRedirectTo({
        pathname: `/conversation/${(conversation as Conversation).expert.id}/${
          (conversation as Conversation).customer.id
        }`,
        state: {
          idConversation: '/conversations/' + (conversation as Conversation).id,
          readOnly: [
            CONVERSATION_STATUS.STOP,
            CONVERSATION_STATUS.FINISHED,
          ].includes(conversation.status),
        },
      });
    }
  };

  if (redirectTo) {
    return <Redirect to={redirectTo} />;
  }

  return (
    <Fragment>
      <div
        className={className ? className : 'start-button'}
        onClick={startConversation}
      >
        <span></span>
        <IonText className="ion-padding-start">
          {text ? text : translate('expert.startChat')}
        </IonText>
      </div>
      {showAvailability ? (
        <IonText color={'success'}>
          <small>{translate('chat.expertOnline')}</small>
        </IonText>
      ) : null}
    </Fragment>
  );
};
